import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { selectSites } from '../sites/sitesSlice';
import { selectUser } from '../user/userSlice';
import { selectSite } from './siteSlice';

export function SiteRedirect() {
  const navigate = useNavigate();
  const { site_id: siteId } = useSelector(selectSite);
  const { sites } = useSelector(selectSites);
  const { isLoggedIn } = useSelector(selectUser);

  useEffect(() => {
    if (isLoggedIn) {
      if (siteId) {
        // If we have a site ID from the store, we can navigate directly to that site
        navigate(`/sites/${siteId}/home`, { replace: true });
      } else if (sites.length === 1) {
        navigate(`/sites/${sites[0].site_id}/home`, { replace: true });
      } else if (!sites.length) {
        navigate('/sites/create', { replace: true });
      } else {
        navigate('/sites', { replace: true });
      }
    } else {
      navigate('/login', { replace: true });
    }
    return;
  }, [isLoggedIn, sites, navigate, siteId]);

  return null;
}
